export const plural = (key, count, params = {}, _locale, t) => {
      const translation = t(key);

      if (!translation) {
        return key;
      }

      // Insert variables into translation
      let translationStr = translation.replaceAll('{count}', count.toString());
      for (const [key, value] of Object.entries(params)) {
        translationStr = translationStr.replaceAll(`{${key}}`, value.toString());
      }

      const forms = translationStr.split('|').map((f) => f.trim());

      // Single form - return as is
      if (forms.length === 1) {
        return forms[0];
      }

      // Two forms: singular (count === 1) or plural (count !== 1)
      if (forms.length === 2) {
        return count === 1 ? forms[0] : forms[1];
      }

      // Three or more forms: index-based selection
      // count = 0 -> forms[0], count = 1 -> forms[1], count >= 2 -> forms[2]
      if (count === 0) {
        return forms[0];
      }

      if (count === 1) {
        return forms[1];
      }

      return forms[Math.min(count, forms.length - 1)];
    };